{
  "CHAT_LIST": {
    "LOADING": "در حال دریافت گفتگوها",
    "LOAD_MORE_CONVERSATIONS": "دریافت گفتگوهای بیشتر",
    "EOF": "همه گفتگوها دریافت شدند 🎉",
    "LIST": {
      "404": "هیچ گفتگوی فعالی در این گروه نیست."
    },
    "FAILED_TO_SEND": "ارسال با خطا مواجه شد",
    "TAB_HEADING": "گفتگوها",
    "MENTION_HEADING": "اشاره",
    "UNATTENDED_HEADING": "بی سرپرست",
    "SEARCH": {
      "INPUT": "پیدا کردن افراد، گفتگوها و پاسخ‌های از پیش نوشته شده..."
    },
    "FILTER_ALL": "همه",
    "ASSIGNEE_TYPE_TABS": {
      "me": "من",
      "unassigned": "تخصیص داده نشده",
      "all": "همه"
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "باز"
      },
      "resolved": {
        "TEXT": "حل شده"
      },
      "pending": {
        "TEXT": "در انتظار"
      },
      "snoozed": {
        "TEXT": "به تعویق افتاد"
      },
      "all": {
        "TEXT": "همه"
      }
    },
    "VIEW_FILTER": "نمایش",
    "SORT_TOOLTIP_LABEL": "مرتب‌سازی گفتگوها",
    "CHAT_SORT": {
      "STATUS": "وضعیت",
      "ORDER_BY": "مرتب بر اساس"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": {
        "LATEST": "ایجاد شده",
        "OLDEST": "ایجاد شده در:"
      },
      "LAST_ACTIVITY": {
        "NOT_ACTIVE": "آخرین فعالیت:",
        "ACTIVE": "آخرین فعالیت"
      }
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "آخرین فعالیت: قدیمی ترین اول"
      },
      "last_activity_at_desc": {
        "TEXT": "آخرین فعالیت: جدید ترین اول"
      },
      "created_at_desc": {
        "TEXT": "زمان ایجاد: جدیدترین اول"
      },
      "created_at_asc": {
        "TEXT": "زمان ایجاد: قدیمی ترین اول"
      },
      "priority_desc": {
        "TEXT": "اولویت: بالاترین اول"
      },
      "priority_asc": {
        "TEXT": "اولویت: پایین ترین اول"
      },
      "waiting_since_asc": {
        "TEXT": "در انتظار پاسخ: بیشترین اول"
      },
      "waiting_since_desc": {
        "TEXT": "در انتظار پاسخ: کم‌ترین اول"
      },
      "priority_desc_created_at_asc": {
        "TEXT": "Priority: Highest first, Created: Oldest first"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "پیام تصویری"
      },
      "audio": {
        "CONTENT": "پیام صوتی"
      },
      "video": {
        "CONTENT": "پیام ویدیویی"
      },
      "file": {
        "CONTENT": "فایل الصاقی"
      },
      "location": {
        "CONTENT": "مکان"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "یک آدرس URL به اشتراک گذاشته شده"
      },
      "contact": {
        "CONTENT": "Shared contact"
      },
      "embed": {
        "CONTENT": "Embedded content"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "مرتب‌سازی گفتگو",
      "DROPDOWN_TITLE": "مرتب‌سازی براساس",
      "ITEMS": {
        "LATEST": {
          "NAME": "آخرین فعالیت در",
          "LABEL": "آخرین فعالیت"
        },
        "CREATED_AT": {
          "NAME": "ایجاد شده در",
          "LABEL": "ایجاد شده در"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "آخرین پیام کاربر در",
          "LABEL": "آخرین پیام"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "از طریق ایمیل دریافت شد",
    "VIEW_TWEET_IN_TWITTER": "مشاهده توییت در توییتر",
    "REPLY_TO_TWEET": "پاسخ به این توییت",
    "LINK_TO_STORY": "برو به داستان اینستاگرام",
    "SENT": "با موفقیت ارسال شد",
    "READ": "با موفقیت خوانده شد",
    "DELIVERED": "با موفقیت تحویل داده شد",
    "NO_MESSAGES": "هیچ پیامی وجود ندارد",
    "NO_CONTENT": "هیچ محتوایی موجود نیست",
    "HIDE_QUOTED_TEXT": "مخفی کردن متن نقل قول شده",
    "SHOW_QUOTED_TEXT": "نمایش متن نقل قول",
    "MESSAGE_READ": "خوانده شده",
    "SENDING": "در حال ارسال",
    "UNREAD_COUNT_OVERFLOW": "9+"
  }
}
